import { render, staticRenderFns } from "./CardLesson.vue?vue&type=template&id=ffa0c142&"
import script from "./CardLesson.vue?vue&type=script&lang=js&"
export * from "./CardLesson.vue?vue&type=script&lang=js&"
import style0 from "./CardLesson.vue?vue&type=style&index=0&id=ffa0c142&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports